import { render, staticRenderFns } from "./client-manage.vue?vue&type=template&id=1cd53384"
import script from "./client-manage.vue?vue&type=script&lang=ts"
export * from "./client-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports